import { AlertBean } from "../../../beans";

export enum AlertsActionEnum {
  ADD = "app/ALERTS/ADD",
  REMOVE = "app/ALERTS/REMOVE",
  RESET = "app/ALERTS/RESET",
  ADD_API_ALERT = "app/ALERTS/ADD_API_ALERT",
  REMOVE_API_ALERT = "app/ALERTS/REMOVE_API_ALERT",
}

export interface IAlertsAdd {
  type: AlertsActionEnum.ADD;
  alerts: AlertBean | AlertBean[];
}
export interface IAlertsRemove {
  type: AlertsActionEnum.REMOVE;
  id: string;
}
export interface IAlertsReset {
  type: AlertsActionEnum.RESET;
}

export interface IAlertsAddApiAlert {
  type: AlertsActionEnum.ADD_API_ALERT;
}
export interface IAlertsRemoveApiAlert {
  type: AlertsActionEnum.REMOVE_API_ALERT;
}

export type AlertsAction =
  | IAlertsAdd
  | IAlertsRemove
  | IAlertsReset
  | IAlertsAddApiAlert
  | IAlertsRemoveApiAlert;

export function alertsAdd(alerts: AlertBean | AlertBean[]): IAlertsAdd {
  return {
    type: AlertsActionEnum.ADD,
    alerts,
  };
}
export function alertsRemove(id: string): IAlertsRemove {
  return {
    type: AlertsActionEnum.REMOVE,
    id,
  };
}
export function alertsReset(): IAlertsReset {
  return {
    type: AlertsActionEnum.RESET,
  };
}

export function alertsAddApiAlert(): IAlertsAddApiAlert {
  return {
    type: AlertsActionEnum.ADD_API_ALERT,
  };
}
export function alertsRemoveApiAlert(): IAlertsRemoveApiAlert {
  return {
    type: AlertsActionEnum.REMOVE_API_ALERT,
  };
}
